module.exports = __webpack_public_path__ + "img/trust_bank.ba4575c0.png";